export const TECH_DRIVE_REFS = [
  'bridge_offline',
  'bridge_online',
  'bridge_permanent',
  'upload_resume',
  'instah_campaign',
];
